import { cloneDeep } from 'lodash';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { delay } from 'rxjs/operators';

import { BaseUI } from '../../base.ui';
import { Country, FullClient, Manager } from '../../../domain/data';
import { ErrorDialog } from '../../dialog/error/error.dialog';
import { GetCountriesUseCase, Nature } from 'src/app/core';
import { ParentEvents } from '../../../utils/parent-events.service';
import { ParentFormDirective } from '../../../directives/parent-form.directive';

@Component({
    selector: 'thr-full-data-three-legal-person',
    templateUrl: './full-data-three-legal-person.component.html',
    styleUrls: ['./full-data-three-legal-person.component.scss'],
})
export class FullDataThreeLegalPersonComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public Nature: typeof Nature = Nature;

    public adding = false;
    public editing = false;
    public currentManager: Manager;
    public countries: Country[] = [];

    public form: NgForm;
    public isFormValid = false;

    @Input()
    client: FullClient;

    @Input()
    isDisabled = false;

    @ViewChild('formDirective')
    formDirective: ParentFormDirective;

    constructor(parentEvents: ParentEvents, private dialog: MatDialog, private getCountriesUseCase: GetCountriesUseCase) {
        super(parentEvents);
    }

    ngOnInit() {
        this.getCountries();

        if (this.client.managers.length === 0) {
            this.onAdd();
        }
    }

    private getCountries() {
        this.getCountriesUseCase
            .bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.countries = transaction.data as Country[];
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.form = this.formDirective.controlContainer as NgForm;

        if (this.form) {
            this.form.statusChanges.subscribe(() => {
                setTimeout(() => {
                    this.isFormValid = this.form.valid;
                });
            });
        }
    }

    onAdd() {
        this.currentManager = new Manager();
        this.adding = true;
        this.editing = false;
    }

    onSave() {
        if (this.adding) {
            this.client.addManager(this.currentManager);
        } else if (this.editing) {
            this.client.updateManager(this.currentManager);
        }

        this.onCancel();
    }

    onCancel() {
        this.adding = false;
        this.editing = false;
        this.currentManager = undefined;

        this.parentEvents.resize();
    }

    onEdit(manager: Manager) {
        this.currentManager = cloneDeep(manager);
        this.editing = true;
        this.adding = false;
    }

    onRemove(manager: Manager) {
        this.client.removeManager(manager);

        if (this.currentManager && String(this.currentManager.id) === String(manager.id)) {
            this.onCancel();
        }

        if (!this.adding && this.client.managers.length === 0) {
            this.onAdd();
        }

        this.parentEvents.resize();
    }
}
